<template>
	<section class="white">
		<v-container>
			<div class="slider">
				<div class="slide-track d-flex align-center">
					<div v-for="(img, index) in marcas" :key="index" class="slide ma-3">
						<v-img :src="img.src"></v-img>
					</div>
				</div>
			</div>
		</v-container>
	</section>
</template>

<script>
export default {
	name: 'Marcas',
	data() {
		return {
			marcas: [
				{ src: require('@/assets/img/marcas/logo1.png') },
				{ src: require('@/assets/img/marcas/logo2.png') },
				{ src: require('@/assets/img/marcas/logo3.png') },
				{ src: require('@/assets/img/marcas/logo4.png') },
				{ src: require('@/assets/img/marcas/logo5.png') },
				{ src: require('@/assets/img/marcas/logo6.png') },
				{ src: require('@/assets/img/marcas/logo7.png') },
				{ src: require('@/assets/img/marcas/logo8.png') },
				{ src: require('@/assets/img/marcas/logo9.png') },
				{ src: require('@/assets/img/marcas/logo10.png') },
				{ src: require('@/assets/img/marcas/logo11.png') },
				{ src: require('@/assets/img/marcas/logo12.png') },
				/* { src: require('@/assets/img/marcas/logo13.png') }, */
				{ src: require('@/assets/img/marcas/logo14.png') },
				{ src: require('@/assets/img/marcas/logo15.png') },
				{ src: require('@/assets/img/marcas/logo16.png') },
				{ src: require('@/assets/img/marcas/logo17.png') },
				{ src: require('@/assets/img/marcas/logo18.png') },
				{ src: require('@/assets/img/marcas/logo19.png') },
				{ src: require('@/assets/img/marcas/logo20.png') },
				{ src: require('@/assets/img/marcas/logo21.png') },
				{ src: require('@/assets/img/marcas/logo22.png') },
				{ src: require('@/assets/img/marcas/logo23.png') },
				{ src: require('@/assets/img/marcas/logo24.png') },
				{ src: require('@/assets/img/marcas/logo25.png') },
				{ src: require('@/assets/img/marcas/logo26.png') },
				{ src: require('@/assets/img/marcas/logo27.png') },
				{ src: require('@/assets/img/marcas/logo28.png') },
				{ src: require('@/assets/img/marcas/logo29.png') },
				{ src: require('@/assets/img/marcas/logo30.png') },
				{ src: require('@/assets/img/marcas/logo31.png') },
				{ src: require('@/assets/img/marcas/logo32.png') },
				{ src: require('@/assets/img/marcas/logo33.png') },
				{ src: require('@/assets/img/marcas/logo34.png') },
				{ src: require('@/assets/img/marcas/logo35.png') },
				{ src: require('@/assets/img/marcas/logo36.png') },
				{ src: require('@/assets/img/marcas/logo37.png') },
				{ src: require('@/assets/img/marcas/logo38.png') },
				{ src: require('@/assets/img/marcas/logo39.png') },
				{ src: require('@/assets/img/marcas/logo40.png') },
				{ src: require('@/assets/img/marcas/41.png') },
				{ src: require('@/assets/img/marcas/logo42.png') },
				{ src: require('@/assets/img/marcas/logo43.png') },
        { src: require('@/assets/img/marcas/logo44.png') },
        { src: require('@/assets/img/marcas/logo46.png') },
        { src: require('@/assets/img/marcas/logo47.png') },
        { src: require('@/assets/img/marcas/logo48.png') },
        { src: require('@/assets/img/marcas/logo49.png') },
        { src: require('@/assets/img/marcas/logo50.png') },
        { src: require('@/assets/img/marcas/logo51.png') },
        { src: require('@/assets/img/marcas/logo52.png') },
        { src: require('@/assets/img/marcas/logo53.png') },
        { src: require('@/assets/img/marcas/logo54.png') },
        { src: require('@/assets/img/marcas/logo55.png') },
        { src: require('@/assets/img/marcas/logo56.png') },
        { src: require('@/assets/img/marcas/logo57.png') },
        { src: require('@/assets/img/marcas/logo58.png') }
			],
			imagenes: '',
		};
	},
	created() {
		this.randomize();
		// this.interval = setInterval(() => slideGroup++, 2000);
	},
	methods: {
		randomize() {
			for (let i = this.marcas.length - 1; i > 0; i--) {
				let randomIndex = Math.floor(Math.random() * i);
				let temp = this.marcas[i];
				this.$set(this.marcas, i, this.marcas[randomIndex]);
				this.$set(this.marcas, randomIndex, temp);
			}
		},
	},
};
</script>

<style scoped>
.slider {
	width: 100%;
	height: auto;
	margin: auto;
	overflow: hidden;
}

.slider .slide-track {
	display: flex;
	animation: scroll 200s linear infinite;
	-webkit-animation: scroll 200s linear infinite;
	width: calc(200px * 43);
}

.slider .slide {
	width: 200px;
}

.slider .slide img {
	width: 100%;
}

@keyframes scroll {
	0% {
		-webkit-transform: translateX(0);
		transform: translateX(0);
	}
	100% {
		-webkit-transform: translateX(calc(-200px * 43));
		transform: translateX(calc(-200px * 43));
	}
}
</style>
